const endingSlash = /\/$/;

const isUrlMatchesRoutes = (url, routes) => {
  const processedUrl = url.replace(endingSlash, '');

  return routes.some((route) => processedUrl === route.replace(endingSlash, ''));
};

export default isUrlMatchesRoutes;
